import { http, json } from "utils/http/client";

function getOrgId() {
  try {
    const org = JSON.parse(localStorage.getItem("organization") || "{}");
    return org?.id ? Number(org.id) : null;
  } catch (_) {
    return null;
  }
}

async function formPost(path, formData) {
  const res = await http(path, { method: "POST", body: formData });
  let data = null;
  try {
    data = await res.json();
  } catch (_) {
    // ignore
  }
  if (!res.ok) {
    const err = new Error(data?.detail || data?.message || res.statusText);
    err.status = res.status;
    err.data = data;
    throw err;
  }
  return data;
}

export const QuotationGeneratorAPI = {
  orgId: getOrgId,

  // Templates
  listTemplates: () => json("/sites/get-all-quotation-templates/", { method: "GET" }),
  getTemplate: (id) => json(`/sites/get-quotation-template/${id}/`, { method: "GET" }),
  createTemplate: (payload) =>
    json("/sites/create-quotation-template/", { method: "POST", body: payload }),
  updateTemplate: (id, payload) =>
    json(`/sites/update-quotation-template/${id}/`, { method: "PUT", body: payload }),
  deleteTemplate: (id) =>
    json(`/sites/delete-quotation-template/${id}/`, { method: "DELETE" }),

  // Quotations
  listQuotations: () => json("/sites/get-all-project-quotations/", { method: "GET" }),
  getQuotation: (id) => json(`/sites/get-project-quotation/${id}/`, { method: "GET" }),
  createQuotation: (formData) => formPost("/sites/create-project-quotation/", formData),
};
